export class CauseDecesAnimal{
    id:number = 0
    nom:string = ""
}